import React, { useEffect, useMemo, useState } from "react";
import { getProduct, getTourDays } from "../api";
import { validateTour } from "../HOC/validateTour";
import _ from "lodash";
// import CovidLogo from "../assets/covidlogo.png";
import Luggage from "../assets/lugg.png";
import { parse } from "himalaya";

const Predeparture = props => {
    const [productDetails, setProductDetails] = useState(null);
    const [tourDays, setTourDays] = useState([]);

    const tourData = useMemo(() => props.data, [props.data]);

    useEffect(() => {
        (async function getAllDetails() {
            const [productRes, tourDayRes] = await Promise.all([
                getProduct(tourData.product[0].id),
                getTourDays(tourData.id),
            ]);
            setProductDetails(productRes);
            setTourDays(_.sortBy(tourDayRes.entries, ["date", "day-order"]));
        })();
    }, [tourData]);

    const recursiveImageSrcFinder = rootNodeArray => {
        return rootNodeArray.reduce((acc, node) => {
            const isImage = node.tagName === "img";

            const childRecursiveAccum = node.children ? recursiveImageSrcFinder(node.children) : [];

            const findSrcValue = () => {
                const srcAttribute = node.attributes.find(attr => attr.key === "src");
                return srcAttribute && srcAttribute.value;
            };
            const srcValue = isImage && findSrcValue();
            return [...acc, ...(srcValue ? [srcValue] : []), ...childRecursiveAccum];
        }, []);
    };

    const imageUrlParser = (htmlString = "") => {
        const content = htmlString.replace(/<img[^>]*>/g, "");
        const json = parse(htmlString);
        const imageSrcArray = recursiveImageSrcFinder(json);
        return (
            <>
                <div
                    className="embedded"
                    dangerouslySetInnerHTML={{
                        __html: content || "_",
                    }}
                />
                {imageSrcArray.length ? (
                    <div
                        style={{
                            gridTemplateColumns: `repeat(${
                                imageSrcArray.length < 2
                                    ? 1
                                    : imageSrcArray.length <= 3
                                      ? imageSrcArray.length
                                      : Math.ceil(3 % imageSrcArray.length)
                            },1fr)`,
                        }}
                        className="images"
                    >
                        {imageSrcArray.map(src => (
                            <a target="__blank" href={src} rel="noreferrer" key={src}>
                                <img src={src} alt="img" />
                            </a>
                        ))}
                    </div>
                ) : null}
            </>
        );
    };

    return (
        tourData &&
        productDetails &&
        tourDays && (
            <div className="info">
                <h1 className="product__title">{tourData.product[0].value} Pre-Departure Information</h1>
                {/* <h3 className="season__title">INFORMATION FOR TOURS {tourData.season[0].value}</h3> */}
                <span>
                    We look forward to meeting you in{" "}
                    {(productDetails["area"] && productDetails["area"][0].value) || "-"} for your{" "}
                    {tourData.product[0].value} with Life's An Adventure. Please see your pre-departure information
                    below.{" "}
                </span>

                <div className="tour-details">
                    <h2 className="tour-title">Flights</h2>
                    {imageUrlParser(tourData["tour-flight-details"])}
                </div>
                <div className="tour-details">
                    <h2 className="tour-title">Airport Transfers</h2>
                    {imageUrlParser(tourData["tour-airport-transfers"])}
                </div>
                <div className="tour-details">
                    <h2 className="tour-title">Pre and Post Accommodation</h2>
                    {imageUrlParser(tourData["tour-pre-post-accommodation"])}
                </div>
                <div className="tour-details">
                    <h2 className="tour-title">Travel Insurance</h2>
                    {tourData["travel-insurance"] || productDetails["travel-insurance"] ? (
                        (tourData["travel-insurance"] && imageUrlParser(tourData["travel-insurance"])) ||
                        imageUrlParser(productDetails["travel-insurance"])
                    ) : (
                        <p className="tour-desc">
                            We often get people who injure themselves before their tour or something unexpected happens
                            and they are unable to make it on their walk, don't take the chance, ensure you take out
                            adequate insurance in case the unforeseen happens. <br /> We strongly advise our clients
                            travelling within Australia to take out Travel Insurance and if you are travelling on one of
                            our overseas walking holidays travel insurance is mandatory. <br />
                            <span className="tour-title">Get a Quote or Purchase Now</span> <br />
                            <span>We have partnered with Cover-More to provide travel insurance to our guests.</span>
                            <ul>
                                {/* 
                                        <li>
                                            <b>VIEW POLICIES</b> – Including some new COVID Policies released Dec 2020. To view
                                            Covermore’s Travel Insurance policy <a href="https://www.lifesanadventure.com.au/covidguarantee/ ">CLICK HERE </a>.
                                        </li> 
                                    */}
                                <li>
                                    <b>GET QUOTE OR PURCHASE:</b>
                                    To get a quote or purchase travel insurance directly with them{" "}
                                    <a href="https://www.lifesanadventure.com.au/travel-insurance/">CLICK HERE </a>.
                                </li>
                            </ul>
                        </p>
                    )}
                </div>
                <div id="meeting" className="tour-details">
                    <h2 className="tour-title">Meeting Details</h2>
                    {imageUrlParser(tourData["tour-meeting-details"])}
                </div>
                <div className="tour-details">
                    <h2 className="tour-title">Contact Details</h2>
                    <p className="tour-desc">
                        {tourData["contact-details"] || productDetails["contact-details"] ? (
                            (tourData["contact-details"] && imageUrlParser(tourData["contact-details"])) ||
                            imageUrlParser(productDetails["contact-details"])
                        ) : (
                            <p>
                                If you are running late or lost on the day please call our emergency phone on 0457 002
                                482. For issues prior to the departure date please call the office on (02) 9975 4553 or
                                email:
                                <a href="https://www.walks@lifesanadventure.com.au">walks@lifesanadventure.com.au</a>
                            </p>
                        )}
                    </p>
                </div>
                {/* Accommodation :TODO */}
                <div id="accommodation" className="tour-details">
                    <h2 className="tour-title">Accommodation Description</h2>
                    <p className="tour-desc"> {imageUrlParser(tourData["accommodation-description"])}</p>
                </div>
                <div id="walk" className="tour-details">
                    <h2 className="tour-title"> About this walk</h2>
                    {imageUrlParser(tourData["tour-about-this-walk"])}
                </div>
                <div className="tour-details">
                    <h2 className="tour-title">Special Dietary Requirements</h2>
                    <p className="tour-desc">
                        {tourData["dietary-requirements"] || productDetails["dietary-requirements"] ? (
                            (tourData["dietary-requirements"] && imageUrlParser(tourData["dietary-requirements"])) ||
                            imageUrlParser(productDetails["dietary-requirements"])
                        ) : (
                            <p>
                                If you have special dietary requirements or an allergic reaction to food please ensure
                                you have indicated this clearly on your booking form especially if your booking was made
                                by someone else in your group. And give us as much details as possible.
                            </p>
                        )}
                    </p>
                </div>

                {tourDays.map((day, i) => {
                    return (
                        <div id="itinerary" className="tour-details" key={day.name + i}>
                            {i === 0 && <h2 className="tour-title"> Tour Itinerary</h2>}
                            <h2 className="tour-title"> {day.name}</h2>
                            {imageUrlParser(day["day-description"])}
                        </div>
                    );
                })}
                <div className="tour-details">
                    <h2 className="tour-title">Important</h2>
                    <p className="tour-desc">
                        {tourData["important"] || productDetails["important"] ? (
                            (tourData["important"] && imageUrlParser(tourData["important"])) ||
                            imageUrlParser(productDetails["important"])
                        ) : (
                            <>
                                <p>
                                    <b>Guided tours include </b> wine or soft drinks with dinner. Whilst we do provide
                                    wine to enjoy during dinner we advise drinking in moderation. Bushwalking can be
                                    very strenuous and excessive alcohol and hiking do not mix. Note: Pre- dinner drinks
                                    are not included in the tour fare, but can be purchased at the bar at your own.
                                </p>
                                <p>
                                    <b> Self Guided tours do NOT include </b> wine or drinks as part of the package -
                                    clients must purchase their own drinks at the bar
                                </p>
                            </>
                        )}
                    </p>
                </div>

                <div className="tour-details">
                    <h2 className="tour-title">Weather</h2>
                    <p className="tour-desc">{imageUrlParser(tourData["tour-weather"])}</p>
                </div>

                <div id="what-to-bring" className="tour-details">
                    <h2 className="tour-title">What to Bring?</h2>
                    <p className="tour-desc">
                        {tourData["tour-what-to-bring"] ? (
                            imageUrlParser(tourData["tour-what-to-bring"])
                        ) : (
                            <p>
                                <b>DOMESTIC TOURS</b>
                                <br />
                                Each client is allowed one suitcase or medium bag for overnight clothes and items, plus
                                a day pack to carry water, your lunch, camera, and any personal items you would like to
                                have with you whilst walking. Please limit your suitcase or medium-sized bag to an
                                absolute <b>maximum of 15kg</b>. Along with the risks posed to our guides handling heavy
                                items, we have limited capacity to take more than this. Most hotels will allow you to
                                leave items if you are travelling with more luggage than this 15kg maximum. Check the
                                weather 2-7 days before travelling to get an up-to-date weather forecast so that you can
                                ensure you bring the appropriate clothing.
                                <br />
                                <br />
                                <b>INTERNATIONAL TOURS</b>
                                <br />
                                Each guest on our international tours is permitted a 23kg suitcase and their additional
                                day pack to carry whilst walking
                            </p>
                        )}
                    </p>
                    <h2 className="tour-title">Luggage</h2>
                    <div style={{ textAlign: "center", marginBottom: "1rem" }}>
                        <img style={{ width: "350px" }} src={Luggage} alt="luggage" />
                    </div>
                    <p className="tour-desc">
                        {(tourData["luggage"] && imageUrlParser(tourData["luggage"])) ||
                            imageUrlParser(productDetails["luggage"])}
                    </p>

                    <h2 className="tour-title">Clothing</h2>
                    <p className="tour-desc">
                        {(tourData["clothing"] && imageUrlParser(tourData["clothing"])) ||
                            imageUrlParser(productDetails["clothing"])}
                    </p>
                </div>

                {(tourData["day-pack"] || productDetails["day-pack"]) && (
                    <div className="tour-details">
                        <h2 className="tour-title">Day Pack</h2>
                        <p className="tour-desc">
                            {(tourData["day-pack"] && imageUrlParser(tourData["day-pack"])) ||
                                imageUrlParser(productDetails["day-pack"])}
                        </p>
                    </div>
                )}

                <div className="tour-details">
                    <h2 className="tour-title">Additional Equipments</h2>
                    <p className="tour-desc">
                        {tourData["additional-equipment"]
                            ? imageUrlParser(tourData["additional-equipment"])
                            : imageUrlParser(productDetails["additional-equipment"])}
                    </p>
                </div>

                {tourData["additional-information"] || productDetails["additional-information"] ? (
                    <div className="tour-details">
                        <h2 className="tour-title">Additional Information</h2>
                        {tourData["additional-information"] || productDetails["additional-information"]
                            ? (tourData["additional-information"] &&
                                  imageUrlParser(tourData["additional-information"])) ||
                              imageUrlParser(productDetails["additional-information"])
                            : null}
                    </div>
                ) : null}

                <div id="solo" className="tour-details">
                    <h2 className="tour-title"> Solo Travellers</h2>
                    {imageUrlParser(tourData["tour-solo-travellers"])}
                </div>

                {tourData["tour-upgrades"] && (
                    <div className="tour-details">
                        <h2 className="tour-title">Upgrades</h2>
                        <p className="tour-desc">{imageUrlParser(tourData["tour-upgrades"])}</p>
                    </div>
                )}

                <div className="tour-details">
                    <h2 className="tour-title">Acknowledgment of Risk Form</h2>

                    <p className="tour-desc">
                        Your acknowledgment of risk-waiver form will need to be completed. Click on the{" "}
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href="https://s3.ap-southeast-2.amazonaws.com/instance-assets.clevero.co/LAA/PDF+FILES/PARTICIPANT+ACKNOWLEDGEMENT+OF+RISK+%26+WAIVER+FORM.pdf"
                        >
                            link
                        </a>{" "}
                        provided to fill out your form and bring it with you on the first day of walking to give to your
                        guide.
                    </p>
                    {/* form: TODO */}
                </div>

                <div id="conditions" className="tour-details">
                    <h2 className="tour-title">Cancellations & Conditions of Travel</h2>

                    <p className="tour-desc">
                        Please ensure that you read our full booking conditions. See link below:
                    </p>
                    <a href="https://www.lifesanadventure.com.au/our-cancellation-policy/">
                        https://www.lifesanadventure.com.au/our-cancellation-policy/
                    </a>
                </div>

                {/* <div id="policies" className="tour-details">
          <h2 className="tour-title">COVID Policies on tour</h2>
          <div style={{ textAlign: "center", marginBottom: "1rem" }}>
            {" "}
            <img style={{ width: "150px" }} src={CovidLogo} />
          </div>

          <p className="tour-desc">
            To keep safe and practice good hygiene we require all guests to be
            vigilant on tour. Please ensure you follow the following procedures
            at all times
          </p>

          <ol>
            <li>
              <p>
                <b>Please sanitise your hands before:</b>
              </p>
              <ul>
                <li>
                  <p>entering the bus each time</p>
                </li>
                <li>
                  <p>at tea and coffee stops on the trail</p>
                </li>
                <li>
                  <p>Lunch stops on the trail</p>
                </li>
                <li>
                  <p>toilet stops at facilities</p>
                </li>
                <li>
                  <p> Before entering the restaurant for dinner each night</p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                <b>
                  Cover your coughs and sneezes with your elbow or a clean
                  tissue (and no spitting){" "}
                </b>
              </p>
            </li>
            <li>
              <p>
                <b>Avoid touching your face, eyes, nose and mouth</b>
              </p>
            </li>
            <li>
              <p>
                <b>
                  Have no intentional physical contact - for example, shaking
                  hands and patting backs.
                </b>
              </p>
            </li>
            <li>
              <p>
                <b>
                  Wait for instructions from guide before entering and
                  disembarking the bus
                </b>
              </p>
            </li>
            <li>
              <p>
                <b>
                  We recommend wearing face masks when travelling on the bus
                </b>
              </p>
            </li>
            <li>
              <p>
                <b>
                  Keep 1.5m distance from other walkers when walking on the
                  trail and stopping to listen to the guide interps
                </b>
              </p>
            </li>
            <li>
              <p>
                <b>
                  At meal times you have the option to sit separately from the
                  group – please ask your guide to arrange this with the
                  restaurant.
                </b>
              </p>
            </li>
          </ol>
        </div> */}
            </div>
        )
    );
};

export default validateTour(Predeparture);
